// NATIVE
import { useEffect, useState } from 'react';

// INSTALLED
import { People } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { getMainData } from '../store/main-data';
import { useDispatch, useSelector } from 'react-redux';
import { MiniCardResumenEmpleados } from '../components/MiniCardResumenEmpleados';
import { MiniCardResumenEmpleadosModal } from '../components/MiniCardResumenEmpleadosModal';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Avatar,
} from '@mui/material';
import { PeriodoPrueba } from '../components/modals/periodo-prueba/PeriodoPrueba';
import { TareasPendientes } from '../components/modals/tareas-pendientes/TareasPendientes';
import { closeSessionGlobal, formatDateToYmd } from '../commons/utils';
import { AvatarTables } from '../components/AvatarTables';
import { AvatarEmployeesInShift } from '../components/AvatarEmployeesInShift';
import { ModalSessionExpired } from '../components/generics/ModalSessionExpired';
import MultipleSnackbars from '../components/MultipleSnackbars';
import { SnackAlert } from '../components/SnackAlert';
import { timeToClosedToast } from '../commons';

// CUSTOM

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export const BasicGrid = () => {
  const dispatch = useDispatch();

  const {
    employeeResume,
    employeeLateResume,
    employePeriodoPruebaResumen,
    employeesTareasPendientes,
    employeesCumpleanos,
  } = useSelector((state: any) => state.employee);

  const [modalType, setModalType] = useState<string | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [timeAlert, setTimeAlert] = useState(timeToClosedToast);

  const [messagesAlerts, setMessagesAlerts] = useState<any>([]);
  const [modalSessionExpired, setModalSessionExpired] = useState<boolean>(false);

  const [alert_snack, setAlertSnack] = useState(false);
  const [msgSnack, setMsgSnack] = useState({
    msg: '',
    status: 'success',
  });

  const handleOpenModal = (type: string) => {
    setModalType(type);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalType(null);
  };

  // resumenEmployeesPeriodoPrueba
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const response = await dispatch(getMainData());

    await validateResponse(response);
  };

  const validateResponse = async (response: any) => {
    if (response.code == 401) {
      await localStorage.removeItem('lastSelectedQypht');
      await closeSessionGlobal();
      setModalSessionExpired(true);
      return false;
    }

    // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO
    if (!response.ok && response.code == 400) {
      const errors: any = [];

      response.errors.forEach((element: any) => {
        errors.push({
          type: 'error',
          text: element,
        });
      });

      setMessagesAlerts(errors);
      return false;
    }

    return true;
  };

  const employeesResume = {
    title: 'Empleados Totales',
    colorTitle: 'white',
    bgTitle: '#1976d2',
    count: employeeResume.total,
    totalText: 'Registrados',
    colorBgIcon: '#1976d2',
    icon: <People fontSize="large" />, // Ej: <PeopleIcon />
    activos: employeeResume.activos,
    inactivos: employeeResume.inactivos,
    totalUsuarios: employeeResume.total,
    withQuantity: true,
    withModal: false,
    goTo: '/talento-humano/empleado',
  };

  const llegadasTardeResume = {
    title: 'Llegadas Tarde',
    colorTitle: 'white',
    bgTitle: '#fab737',
    count: employeeLateResume,
    totalText: 'Llegadas tarde',
    colorBgIcon: '#fab737',
    icon: <People fontSize="large" />, // Ej: <PeopleIcon />
    activos: employeeLateResume,
    inactivos: employeeLateResume,
    totalUsuarios: employeeLateResume,
    withQuantity: false,
    withModal: false,
    goTo: '/talento-humano/control-tiempos',
  };

  const tareasPendientesResume = {
    title: 'Tareas Pendientes',
    colorTitle: 'white',
    bgTitle: '#FF7374',
    count: employeesTareasPendientes.length,
    totalText: 'Tareas pendientes',
    colorBgIcon: '#FF7374',
    icon: <People fontSize="large" />, // Ej: <PeopleIcon />
    activos: employeesTareasPendientes.length,
    inactivos: employeesTareasPendientes.length,
    totalUsuarios: employeesTareasPendientes.length,
    withQuantity: false,
    withModal: true,
    onOpenModal: handleOpenModal,
    modalType: 'tareasPendientes', // puedes cambiar por "activos", "inactivos", etc.
  };

  const periodoPruebaResume = {
    title: 'Periodo Prueba',
    colorTitle: 'white',
    bgTitle: '#26e7a5',
    count: employePeriodoPruebaResumen.length,
    totalText: 'Periodo prueba',
    colorBgIcon: '#26e7a5',
    icon: <People fontSize="large" />, // Ej: <PeopleIcon />
    activos: employeeResume.activos,
    inactivos: employeeResume.inactivos,
    totalUsuarios: employePeriodoPruebaResumen.length,
    withQuantity: false,
    withModal: true,
    onOpenModal: handleOpenModal,
    modalType: 'periodoPrueba', // puedes cambiar por "activos", "inactivos", etc.
  };

  return (
    <>
      <ModalSessionExpired open={modalSessionExpired} />
      <MultipleSnackbars
        messagesList={messagesAlerts}
        position={'bottom-left'}
        autoClose={timeAlert}
      />
      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={msgSnack.msg}
        severity={msgSnack.status}
      />

      <Box sx={{ flexGrow: 1 }} mt={5}>
        <Box display="flex" justifyContent="start" gap={2}>
          <Box flexBasis="33.33%">
            <MiniCardResumenEmpleados {...employeesResume} />
          </Box>
          <Box flexBasis="33.33%">
            <MiniCardResumenEmpleados {...llegadasTardeResume} />
          </Box>
          <Box flexBasis="33.33%">
            <MiniCardResumenEmpleadosModal {...tareasPendientesResume} />
          </Box>
          <Box flexBasis="33.33%">
            <MiniCardResumenEmpleadosModal {...periodoPruebaResume} />
          </Box>
        </Box>
      </Box>
      <Box mt={10}>
        <Paper elevation={4} sx={{ borderRadius: 3, overflow: 'hidden' }}>
          <Box p={2} sx={{ backgroundColor: '#1976d2', color: 'white' }}>
            <Typography variant="h6" fontWeight="bold">
              🎂 Cumpleaños de{' '}
              {new Date().toLocaleString('es-ES', { month: 'long' }).charAt(0).toUpperCase() +
                new Date().toLocaleString('es-ES', { month: 'long' }).slice(1)}
            </Typography>
          </Box>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell>
                    <strong>Avatar</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Nombre</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Fecha Nacimiento</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Edad</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Mensaje</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Reemplaza con tus datos dinámicos employeesCumpleanos */}
                {employeesCumpleanos.map((emp: any) => (
                  <TableRow hover key={emp.id}>
                    <TableCell>
                      <AvatarEmployeesInShift
                        urlImage={emp.employee_avatar || 'default.png'}
                        typeImage="image-employee"
                      />
                    </TableCell>
                    <TableCell>{emp.name}</TableCell>
                    <TableCell>{formatDateToYmd(emp.birthdate)}</TableCell>
                    <TableCell>{emp.edad}</TableCell>
                    <TableCell>🎉 ¡Feliz cumpleaños!</TableCell>
                  </TableRow>
                ))}
                {/* Más filas si es necesario */}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>

      {modalType === 'tareasPendientes' && (
        <TareasPendientes open={modalOpen} handleCloseModal={handleCloseModal} />
      )}

      {modalType === 'periodoPrueba' && (
        <PeriodoPrueba open={modalOpen} handleCloseModal={handleCloseModal} />
      )}
    </>
  );
};
